import "./FreeTrialBanner.scss"

import { BannerNotification, BannerVariant } from "@skylead/component-library"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"

import { triggerEndFreeTrialModal } from "../../../redux/app/appActions"
import { useGlobalTranslation } from "../../../utils/hook"
import { isInFreeTrial } from "../../../utils/payment-utils"

const FreeTrialBanner = ({
  isInMasterLoginPage = false,
  isInWLAdminPage = false,
  userID,
  allSubscriptions,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { tt } = useGlobalTranslation()

  const [inFreeTrial, setInFreeTrial] = useState(false)

  useEffect(() => {
    setInFreeTrial(isInFreeTrial(allSubscriptions))
  }, [allSubscriptions])

  const triggerEndFreeTrial = async () => {
    if (!isInMasterLoginPage && !isInWLAdminPage) {
      navigate(`/users/${userID}`)
    }
    dispatch(triggerEndFreeTrialModal(true))
  }

  const renderRemainingDays = () =>
    !!allSubscriptions[0] &&
    Math.ceil((allSubscriptions[0].subscriptionEndsAt - Date.now() / 1000) / 86400)

  if (inFreeTrial)
    return (
      <BannerNotification
        type={BannerVariant.FREE_TRAIL}
        label={tt("free.trial.banner.label", { action: renderRemainingDays() })}
        showButton
        buttonLabel={tt("free.trial.banner.button-label")}
        onClick={triggerEndFreeTrial}
      />
    )

  return null
}

// FreeTrialBanner.propTtpes = {
//   isInMasterLoginPage: PropTypes.bool,
//   isInWLAdminPage: PropTypes.bool,
//   userID: PropTypes.number.isRequired,
//   allSubscriptions: PropTypes.arrayOf(
//     PropTypes.shape({
//       id: PropTypes.number,
//       status: PropTypes.string,
//       subscriptionEndsAt: PropTypes.number,
//     }),
//   ).isRequired,
// }

export default FreeTrialBanner
